import type { Breadcrumb } from '@ori/presentation-components';
import type { Dispatch } from 'react';

import type { TopAreaApiResponse } from '../models';
import type { ActionsType } from './actions';
import { setBannerData, setBreadCrumbsData, setIsSubnavNested } from './actions';

export function buildSetters(dispatch: Dispatch<ActionsType>) {
  return {
    setBannerData(data: TopAreaApiResponse) {
      dispatch(setBannerData(data));
    },
    setBreadCrumbsData(data: Breadcrumb[]) {
      dispatch(setBreadCrumbsData(data));
    },
    setIsSubnavNested(data: boolean) {
      dispatch(setIsSubnavNested(data));
    },
  } as const;
}
